import { graphql } from "@/graphql/generated/gql";
// ============== QUERIES ======================
export const userFavoritesQueryDocument = graphql(/* GraphQL */ `
  query GetUserFavoriteList($getUserFavoriteListInput: UserFavoriteGetInput!) {
    getUserFavoriteList(getUserFavoriteListInput: $getUserFavoriteListInput) {
      id
      userId
      pageUrl
      pageName
      workspaceId
    }
  }
`);

// ============== MUTATIONS ======================
export const createUserFavoriteMutationDocument = graphql(/* GraphQL */ `
  mutation CreateUserFavorite($input: UserFavoriteCreateInput!) {
    createUserFavorite(userFavoriteCreateInput: $input) {
      id
      userId
      pageUrl
      pageName
      workspaceId
    }
  }
`);

export const deleteUserFavoriteMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteUserFavorite($input: UserFavoriteDeleteInput!) {
    deleteUserFavorite(userFavoriteDeleteInput: $input) {
      id
      userId
      pageUrl
      pageName
      workspaceId
    }
  }
`);
